import { useEffect, useState } from "react";
import { TrashIcon } from "@heroicons/react/24/outline";
import { formatCurrencyVND } from "../../utils/helps";
import { getProvinces, getDistricts } from "vietnam-provinces";
import { useDispatch } from "react-redux";
import { createOrders } from "../../features/admin/OrderSlice";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import ConfirmModal from "../../components/ConfirmModal";
import { showUserById } from "../../features/admin/UserSlice";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/solid";
import ApiCustom from "../../utils/ApiCustom";

export default function ShoppingCart() {
  const [cart, setCart] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [districtsAll, setDistrictsAll] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("Thành phố Cần Thơ");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [titleButton, setTitleButton] = useState("Đặt hàng");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [couponCodes, setCouponCodes] = useState({});

  const handleCouponChange = (itemId, value) => {
    setCouponCodes((prev) => ({
      ...prev,
      [itemId]: value,
    }));
  };

  const deleteCoupon = (itemId) => {
    const cartQuantity = cart.map((item) =>
      item.id == itemId ? { ...item, coupon: null } : item,
    );
    setCart(cartQuantity);
    localStorage.setItem("cart", JSON.stringify(cartQuantity));
    toast.success("Xoá mã thưởng thành công");
  };

  const applyCoupon = (itemId) => {
    const couponCode = couponCodes[itemId];

    ApiCustom.get("/coupon-show-by-code/" + couponCode)
      .then((res) => {
        const data = res.data.data;
        const now = new Date();
        if (data.userId != userId) {
          toast.error("Mã thưởng không hợp lệ hoặc đã hết hạn");
          return;
        }
        if (data.productId != itemId) {
          toast.error("Mã của bạn không thể dùng cho sản phẩm này");
          return;
        }
        if (data.status != "active") {
          toast.error("Mã của bạn đã được sử dụng");
          return;
        }
        if (now < new Date(data.startDate) || now > new Date(data.endDate)) {
          toast.error("Mã của bạn đã hết hạn");
          return;
        }
        toast.success("Áp dụng mã thành công");
        const cartQuantity = cart.map((item) =>
          item.id == itemId ? { ...item, coupon: data } : item,
        );
        setCart(cartQuantity);
        localStorage.setItem("cart", JSON.stringify(cartQuantity));
        setCouponCodes("");
      })
      .catch((err) => {
        toast.error(err.response.data.messages);
      });
  };

  // const handleOpenModal = () => {
  //   const hasItemWithCoupon = cart.some(
  //     (item) => item.quantity > 1 && item.coupon !== null,
  //   );
  //   if (hasItemWithCoupon) {
  //     setIsOpenModal(true);
  //   } else {
  //     handleOrder();
  //   }
  // };

  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  const [customer, setCustomer] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    note: "",
  });

  const userId = localStorage.getItem("userId");
  useEffect(() => {
    window.scrollTo(0, 0);
    setTitleButton("Đặt hàng");
    const initialCart = JSON.parse(localStorage.getItem("cart"));
    if (!initialCart) {
      localStorage.setItem("cart", JSON.stringify([]));
    }
    setCart(initialCart || []);

    const provinceData = getProvinces();
    const districtData = getDistricts();
    const defaultProvince = "Thành phố Cần Thơ";

    setProvinces(provinceData);
    setDistrictsAll(districtData);
    setSelectedProvince(defaultProvince);

    const selectedProvinceData = provinceData.find(
      (province) => province.name === defaultProvince,
    );

    if (selectedProvinceData) {
      const selectedDistrictData = districtData.filter(
        (district) => district.province_name === selectedProvinceData.name,
      );
      setDistricts(selectedDistrictData ?? []);
    }

    getUserInfo();
  }, []);

  const getUserInfo = async () => {
    try {
      const userInfoData = await dispatch(showUserById(userId)).unwrap();
      setCustomer({
        name: userInfoData.userFullName,
        phone: userInfoData.userPhone,
        email: userInfoData.userEmail,
        address: userInfoData.userAddress,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleProvinceChange = (e) => {
    const provinceName = e.target.value;
    setSelectedProvince(provinceName);

    const selectedProvinceData = provinces.find(
      (province) => province.name === provinceName,
    );
    if (selectedProvinceData) {
      const selectedDistrictData = districtsAll.filter(
        (districts) => districts.province_name === selectedProvinceData.name,
      );
      setDistricts(selectedDistrictData ?? []);
    } else {
      setDistricts([]);
    }
    setSelectedDistrict("");
  };

  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value);
  };

  const updateQuantity = (id, quantity) => {
    const cartQuantity = cart.map((item) =>
      item.id === id ? { ...item, quantity } : item,
    );
    setCart(cartQuantity);
    localStorage.setItem("cart", JSON.stringify(cartQuantity));
  };

  const removeItem = (id) => {
    const cartRemove = cart.filter((item) => item.id !== id);
    setCart(cartRemove);
    localStorage.setItem("cart", JSON.stringify(cartRemove));
    navigate(``);
  };

  const handleChange = (e) => {
    if (e.target.name == "note" && e.target.value != "") {
      setTitleButton("Giới thiệu đặt hàng");
    } else {
      setTitleButton("Đặt hàng");
    }
    setCustomer({ ...customer, [e.target.name]: e.target.value });
  };

  const handleOrder = async () => {
    const orderPost = {
      customerId: userId,
      fullName: customer.name,
      phone: customer.phone,
      email: customer.email,
      province: selectedProvince,
      district: selectedDistrict,
      address: customer.address,
      note: customer.note,
      details: cart,
    };
    if (
      customer.name === "" ||
      customer.phone === "" ||
      customer.email === "" ||
      customer.address === ""
    ) {
      toast.error("Vui lòng nhập đầy đủ thông tin");
      return;
    }
    if (selectedDistrict === "" || selectedProvince === "") {
      toast.error("Vui lòng Chọn tỉnh/thành phố và Quận/huyện");
      return;
    }
    setIsButtonDisabled(true);
    setTitleButton("Đang xử lý ...");
    try {
      await dispatch(createOrders(orderPost)).unwrap();
      toast.success("Thêm giao dịch thành công!");
      localStorage.setItem("cart", JSON.stringify([]));
      navigate(`/`);
    } catch (error) {
      if (error?.status == 400) {
        toast.error(error?.messages);
      }
    } finally {
      setIsButtonDisabled(false);
      setTitleButton("Đặt hàng");
    }
  };

  const hasContactPriceProduct = cart?.some(
    (item) => item?.isContactPrice === true,
  );

  const total = hasContactPriceProduct
    ? null
    : cart?.reduce(
        (sum, item) =>
          sum + item.price * item.quantity - Number(item.coupon?.price || 0),
        0,
      );

  if (cart?.length < 1) {
    return (
      <div className="container mx-auto p-6 text-center flex flex-col gap-10 items-center">
        <div>Không có sản phẩm trong giỏ hàng</div>
        <div className="w-48">
          <Link to={"/"} className="border rounded-xl p-3 bg-red-100">
            Trở về trang chủ
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6 text-center">Đặt hàng </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="p-4 bg-base-100 shadow-md rounded-lg">
          <h2 className="text-xl font-semibold mb-4">Sản phẩm</h2>
          <div className="grid gap-4">
            {cart.length > 0 ? (
              cart.map((item) => (
                <div
                  key={item.id}
                  className="flex flex-col border rounded-lg p-3"
                >
                  <div className="flex justify-between items-center gap-4">
                    <div className="flex items-center space-x-4">
                      {/* Hình ảnh sản phẩm */}
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-24 h-24 object-cover rounded-lg border"
                      />
                      <div>
                        <h3 className="text-lg font-medium">{item.name}</h3>
                        <p className="text-gray-600">
                          {item?.isContactPrice === true
                            ? "Liên hệ"
                            : formatCurrencyVND(item.price)}
                        </p>
                        {item.coupon && item?.isContactPrice !== true && (
                          <div className="">
                            {item?.coupon?.code} (-{" "}
                            {formatCurrencyVND(item?.coupon?.price)})
                          </div>
                        )}
                        {item.gift &&
                          item.condition &&
                          item.condition <= item.price * item.quantity && (
                            <div className="flex items-center animate-rgb-glow">
                              <label className="font-medium text-sm">
                                {item.gift}
                              </label>
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="space-y-2">
                      <div className="flex items-center space-x-4">
                        <input
                          type="number"
                          min="1"
                          value={item.quantity}
                          onChange={(e) =>
                            updateQuantity(item.id, parseInt(e.target.value))
                          }
                          className="input input-bordered w-20 text-center"
                        />
                        <button
                          className="btn btn-error"
                          onClick={() => removeItem(item.id)}
                        >
                          <TrashIcon className="w-6 h-6" />
                        </button>
                      </div>
                      <div className="flex justify-center gap-2 items-center hidden">
                        <input
                          type="search"
                          min="1"
                          value={couponCodes[item.id] || ""}
                          placeholder="Mã thưởng"
                          onChange={(e) =>
                            handleCouponChange(item.id, e.target.value)
                          }
                          className="input input-bordered w-36"
                        />
                        <div className="space-y-1">
                          <button
                            className="border btn btn-outline btn-success btn-sm"
                            onClick={() => applyCoupon(item.id)}
                          >
                            <CheckIcon className="h-5 w-5" />
                          </button>
                          <button
                            className="border btn btn-outline btn-error btn-sm"
                            onClick={() => deleteCoupon(item.id)}
                          >
                            <XMarkIcon className="w-5 h-5" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* {item.quantity > 1 && item.coupon && (
                   <p className="text-sm mt-1 text-red-600">
                     Khuyến mãi chỉ áp dụng cho số lượng sản phẩm nhất định *
                   </p>
                 )} */}
                </div>
              ))
            ) : (
              <p className="text-gray-500">Giỏ hàng trống.</p>
            )}
          </div>
          <div className="mt-4 flex justify-between items-center border-t pt-4">
            <h2 className="text-lg font-semibold">Tổng cộng:</h2>
            <p className="text-xl font-bold text-red-600">
              {hasContactPriceProduct ? "Liên hệ" : formatCurrencyVND(total)}
            </p>
          </div>
        </div>

        <div className="p-4 bg-base-100 shadow-md rounded-lg">
          <h2 className="text-xl font-semibold mb-4">Thông tin khách hàng</h2>
          <div className="space-y-4">
            <input
              type="text"
              name="name"
              value={customer.name}
              onChange={handleChange}
              placeholder="Họ và tên*"
              className="input input-bordered w-full"
            />
            <input
              type="text"
              name="phone"
              value={customer.phone}
              onChange={handleChange}
              placeholder="Số điện thoại*"
              className="input input-bordered w-full"
            />
            <input
              type="text"
              name="email"
              value={customer.email}
              onChange={handleChange}
              placeholder="Email*"
              className="input input-bordered w-full"
            />
            <select
              name="city"
              value={selectedProvince}
              onChange={handleProvinceChange}
              className="select select-bordered w-full"
            >
              <option value="">Chọn Tỉnh/Thành phố*</option>
              {provinces.map((item, idx) => (
                <option key={idx} value={item.name}>
                  {item.name}
                </option>
              ))}
            </select>

            <select
              name="district"
              value={selectedDistrict}
              onChange={handleDistrictChange}
              className="select select-bordered w-full"
            >
              <option value="">Chọn Quận/Huyện*</option>
              {districts.map((item, idx) => (
                <option key={idx} value={item.name}>
                  {item.name}
                </option>
              ))}
            </select>
            <textarea
              name="address"
              value={customer.address}
              onChange={handleChange}
              placeholder="Địa chỉ nhận hàng*"
              className="textarea textarea-bordered w-full"
            ></textarea>
            <textarea
              name="note"
              value={customer.note}
              onChange={handleChange}
              placeholder="Thông tin giới thiệu người mua hàng (tên, số điện thoại)"
              className="textarea textarea-bordered w-full"
            ></textarea>
          </div>
          <button
            className="btn btn-primary w-full mt-4"
            onClick={handleOrder}
            disabled={isButtonDisabled}
          >
            {titleButton}
          </button>
        </div>
      </div>

      <ConfirmModal
        isOpen={isOpenModal}
        onClose={handleCloseModal}
        message={
          "Mã thưởng chỉ áp dụng cho 1 sản phẩm \n bạn có muốn tiếp tục đặt hàng không?"
        }
        onSubmit={() => {
          handleOrder();
          setIsOpenModal(false);
        }}
      />
    </div>
  );
}